<template lang="pug">
  v-container.pt-6.px-10(fluid)
    v-breadcrumbs.pt-0.px-0.pb-3(:items="breadcrumbItems")
      template(v-slot:item="{ item }")
        a.text-sm.font-medium.no-underline.neutral700--text(v-if="!item.disabled" @click="item.href") {{ item.text }}
        .text-sm.neutral700--text(v-else) {{ item.text }}

    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
    template(v-else)
      .d-flex.align-center.justify-space-between
        .d-flex.align-center
          v-btn.ml-n3(text icon @click="goBack" height)
            v-icon(color="neutral700" :size="24") mdi-arrow-left
          .text-2xl.font-semibold.neutral700--text.ml-3(v-if="service") {{ service.product.name }}
        hq-branch-dropdown(v-model="branchFilter")

      v-divider.mt-4

      .data-table
        v-data-table.mt-sm-4.pb-6(:headers="headers" :items="records" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetchingRecords" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }")
          //- date time
          template(v-slot:item.datetime="{ item }")
            .text-sm.neutral700--text {{ item.datetime | convertServerDate2 }}
          //- branches
          template(v-slot:item.company_name="{ item }")
            .text-sm.neutral700--text(v-if="item.company") {{ item.company.name }}
          //- quantity
          template(v-slot:item.quantity="{ item }")
            .text-sm.neutral700--text {{ item.quantity }}
          //- price tier
          template(v-slot:item.price_tier="{ item }")
            .text-sm.neutral700--text {{ item.extra_data && item.extra_data.price_tier_name }}
          //- price
          template(v-slot:item.price="{ item }")
            .text-sm.neutral700--text.no-wrap {{ item.price | displayPrice($currency) }}
          //- invoice no
          template(v-slot:item.rid="{ item }")
            .text-sm.neutral700--text INV {{ `#${item.rid}` }}
          //- patient
          template(v-slot:item.customer="{ item }")
            div.my-1(v-if="item.customer")
              .text-sm.neutral700--text {{ item.customer.name }}
              .text-xs.neutral500--text {{ item.customer.ic }}

      div.d-flex.align-center(v-if="totalCount > pageSize")
        v-spacer
        yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HqBranchDropdown from '@/components/hq/inventory/HqBranchDropdown.vue'

export default {
  name: 'HqServiceHistory',
  components: { HqBranchDropdown },
  props: ['id'],
  data () {
    return {
      isFetching: false,
      isFetchingRecords: false,
      pageSize: 20,
      totalCount: 0,
      currentPage: 1,
      service: null,
      branchFilter: null,
      records: [],
      headers: [
        { text: 'Date and time', value: 'datetime', enable: true, class: 'text-table-header' },
        { text: 'Branches', value: 'company_name', enable: true, class: 'text-table-header', sortable: false },
        { text: 'Qty', value: 'quantity', enable: true, class: 'text-table-header', sortable: false },
        { text: 'Price tier', value: 'price_tier', enable: true, class: 'text-table-header' },
        { text: 'Price', value: 'price', enable: true, class: 'text-table-header' },
        { text: 'Invoice no', value: 'rid', enable: true, class: 'text-table-header' },
        { text: 'Patient', value: 'customer', enable: true, class: 'text-table-header' },
      ],
      breadcrumbItems: [
        { text: 'Services', disabled: false, href: () => (this.goToServices()) },
        { text: 'Service history', disabled: true }
      ]
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    companyParam () {
      if (Array.isArray(this.branchFilter) && this.branchFilter.length) {
        return this.branchFilter.map(b => b.id).join(',')
      }
      return null
    },
  },
  watch: {
    pageSize () {
      this.currentPage = 1
      this.fetchServiceHistory()
    },
    branchFilter () {
      this.currentPage = 1
      this.fetchServiceHistory()
    }
  },
  mounted () {
    this.fetchService()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchService () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/hq/services/${this.id}`)
        .then(resp => {
          this.service = resp.data
          this.fetchServiceHistory()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchServiceHistory () {
      if (!this.service) return
      this.isFetchingRecords = true
      let params = {
        form_types: 'registration',
        page: this.currentPage,
        page_size: this.pageSize
      }
      if (this.companyParam) { params.companies = this.companyParam }
      this.$axios.get(`/products/${this.service.product.id}/sales`, { params })
        .then(resp => {
          this.records = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingRecords = false
        })
    },
    pageChanged () {
      this.fetchServiceHistory()
    },
    goToServices () {
      return this.$router.push({ name: 'HQInventoryServices' }).catch(() => {})
    },
    goBack () {
      let route = { name: 'HQInventoryServices' }
      if (this.$route?.params?.origin === 'HQEditService') {
        route = { name: 'HQEditService', params: { id: this.id } }
      }
      return this.$router.push(route).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-width {
  width: 50px !important;
}
</style>
